import { httpCreate } from './http';

const http = httpCreate('/shop/api/store/');

export const store = {
	// getCreatorStore(userid) {
	// 	return http.get(`/${userid}`);
	// },
	updateStore(id, data) {
		return http.put(`/${id}`, data);
	}
};
